import SaleDashboard from './widgets/SaleDashboard';

const SaleDashboardPage = () => {
  return <SaleDashboard />;
};

export default SaleDashboardPage;
